<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="访客姓名" prop="userName" style="width: 80%">
                <el-input
                  v-model="searchForm.userName"
                  placeholder="请输入访客姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="时间选择" prop="userName" style="width: 80%">
                <el-date-picker
                  v-model="searchForm.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
            </el-col>            
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="inviteUserName" label="邀请人" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="访客姓名" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="访客手机号码" align="center">
        </el-table-column>
        <el-table-column prop="peopleCount" label="随行人员" align="center">
        </el-table-column>        
        <el-table-column prop="workUnit" label="工作单位" align="center">
        </el-table-column>        
        <el-table-column prop="subscribeTime" label="预约来访时间" align="center">
        </el-table-column>    
        <el-table-column prop="address" label="到访地址" align="center">
        </el-table-column> 
        <el-table-column prop="carNo" label="车牌信息" align="center">
        </el-table-column>           
        <el-table-column prop="type" label="来访类型" align="center" :formatter="typeList">
        </el-table-column>           
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import reg from '../../utils/reg'
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading:false,
      searchForm: {
        userName: "",
        startTIme:'',
        endTime:'',
        time:''
      },
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    typeList(row){
      return row.type == 1 ? '访客邀约' : '访客登记'
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad(ind) {
      this.currentPage = ind == 1 ? 1 : this.currentPage
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        userName:this.searchForm.userName,
        startTime:reg.filterDataTime(this.searchForm.time[0]) || '', 
        endTime:reg.filterDataTime(this.searchForm.time[1]) || '', 
      }
      this.$Apis.visitorList(data).then(res=>{
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>